(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  const reviewBox = document.getElementById(
    'HomeHeroReviews-{{ section.id }}'
  );

  if (!reviewBox) {
    return;
  }


  /* =======================================================
     STAR RENDERER
     ======================================================= */

  function setHeroRating(rating) {

    rating = parseFloat(rating);

    if (Number.isNaN(rating)) {
      return;
    }

    rating = Math.max(0, Math.min(5, rating));

    const stars =
      reviewBox.querySelectorAll('.home-hero__star');


    stars.forEach(function (star, index) {

      const value =
        Math.max(
          0,
          Math.min(
            1,
            rating - index
          )
        );

      const fill =
        star.querySelector('.home-hero__star-fill');

      if (fill) {
        fill.style.width = (value * 100) + '%';
      }

    });


    const ratingText =
      document.getElementById(
        'HomeHeroRating-{{ section.id }}'
      );

    if (ratingText) {
      ratingText.textContent =
        rating.toFixed(1);
    }


    const starsContainer =
      document.getElementById(
        'HomeHeroStars-{{ section.id }}'
      );

    if (starsContainer) {
      starsContainer.setAttribute(
        'aria-label',
        rating.toFixed(1) + ' out of 5 stars'
      );
    }

  }


  setHeroRating(
    reviewBox.dataset.rating
  );


  /* =======================================================
     OPTIONAL GOOGLE REVIEW FEED
     ======================================================= */

  const googleEnabled =
    reviewBox.dataset.googleEnabled === 'true';

  const feedUrl =
    reviewBox.dataset.googleFeed;


  if (!googleEnabled || !feedUrl) {
    return;
  }


  fetch(feedUrl, {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  })

  .then(function (response) {

    if (!response.ok) {
      throw new Error(
        'Google review feed unavailable'
      );
    }

    return response.json();

  })

  .then(function (data) {

    if (typeof data.rating === 'number') {

      setHeroRating(
        data.rating
      );

    }


    if (
      typeof data.count === 'number'
      || typeof data.count === 'string'
    ) {

      const count =
        document.getElementById(
          'HomeHeroReviewCount-{{ section.id }}'
        );

      if (count) {

        count.textContent =
          '· ' +
          data.count +
          ' reviews';

      }

    }


    if (data.google_maps_url) {

      const link =
        document.getElementById(
          'HomeHeroGoogleLink-{{ section.id }}'
        );

      if (link) {

        link.href =
          data.google_maps_url;

        link.classList.remove(
          'home-hero__google-link--hidden'
        );

      }

    }

  })

  .catch(function (error) {

    console.warn(
      'Google reviews could not be loaded.',
      error
    );

  });

});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
